import type { Watch } from '@/lib/myWatches/types';
import type { WatchProductSummary } from '@/lib/service/ecs/contracts';
import { resolveWatchReference } from '@/lib/service/resolveWatchReference';

export interface RepairWatchContext {
  serialNumber: string;
  referenceNumber: string | null;
  watchWarranty: Watch | null;
  watchProductSummary: WatchProductSummary | null;
}

export async function loadRepairWatchContext(params: {
  serialNumber: string;
  locale: string;
  countryCode: string;
  serialOnly?: boolean;
}): Promise<RepairWatchContext> {
  const serialNumber = params.serialNumber.trim();
  const empty: RepairWatchContext = {
    serialNumber,
    referenceNumber: null,
    watchWarranty: null,
    watchProductSummary: null,
  };

  if (!serialNumber) return empty;

  const resolved = await resolveWatchReference({
    input: serialNumber,
    locale: params.locale,
    countryCode: params.countryCode,
    serialOnly: params.serialOnly,
  });

  if (resolved.status !== 'identified') {
    return empty;
  }

  return {
    serialNumber: resolved.serialNumber ?? serialNumber,
    referenceNumber: resolved.referenceNumber,
    watchWarranty: resolved.watchWarranty ?? null,
    watchProductSummary: resolved.watchProductSummary,
  };
}
